import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getSnowFormData,
  RITMActivity,
  SnowIdData,
} from "./engagementSnowHistoryService";

interface EngagementHistoryState {
  isSnowForm: boolean;
  isCkms: boolean;
  pending: boolean;
  data: any[];
  snowActivity: any[];
  RITMActivity: any[];
  page: number;
  total: number;
}
interface snowFornParams {
  page: number;
  limit: number;
}
const initialState: EngagementHistoryState = {
  isSnowForm: false,
  isCkms: true,
  pending: false,
  page: 1,
  total: 0,
  snowActivity: [],
  RITMActivity: [],
  data: [],
};

const engagementHistorySlice = createSlice({
  name: "engagementHistory",
  initialState,
  reducers: {
    setSnowForm: (state) => {
      state.isSnowForm = true;
      state.isCkms = false;
    },
    setCkms: (state) => {
      state.isSnowForm = false;
      state.isCkms = true;
    },
    setSnowPage: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSnowFormTableData.pending, (state) => {
      state.pending = true;
    });
    builder.addCase(getSnowFormTableData.fulfilled, (state, action) => {
      state.pending = false;
      state.data = action.payload.data;
      state.total = action.payload.total;
      state.page = action.payload.page;
    });
    builder.addCase(getSnowFormTableData.rejected, (state) => {
      state.pending = false;
    });
    builder.addCase(getSnowActivityData.pending, (state) => {
      state.pending = true;
    });
    builder.addCase(getSnowActivityData.fulfilled, (state, action) => {
      state.pending = false;
      state.snowActivity = action.payload.data;
    });
    builder.addCase(getSnowActivityData.rejected, (state) => {
      state.pending = false;
    });
    builder.addCase(getRITMActivityData.pending, (state) => {
      state.pending = true;
    });
    builder.addCase(getRITMActivityData.fulfilled, (state, action) => {
      state.pending = false;
      const payloadData = action.payload.data[0] || {}; 
      const stageDifferences = payloadData.stage_differences || [];
      const stateDifferences = payloadData.state_differences || [];
      const createdAtValues = payloadData.created_at_values || [];
      const maxLength = Math.max(
        stageDifferences.length,
        stateDifferences.length,
        createdAtValues.length
      );
      const transformedData = Array.from({ length: maxLength }).map(
        (_, index) => ({
          stage: stageDifferences[index] || "",
          state: stateDifferences[index] || "",
          createdAt: createdAtValues[index] || "",
        })
      );
      state.RITMActivity = transformedData.reverse();
    });
    builder.addCase(getRITMActivityData.rejected, (state) => {
      state.pending = false;
    });
  },
});
export const getSnowFormTableData = createAsyncThunk<any, snowFornParams>(
  "engagementHistory/getSnowFormTableData",
  async (args, thunkAPI) => {
    try {
      const response = await getSnowFormData(args);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const getSnowActivityData = createAsyncThunk<any, { snow_id: number }>(
  "engagementHistory/getSnowActivityData",
  async (args, thunkAPI) => {
    try {
      const response = await SnowIdData(args);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const getRITMActivityData = createAsyncThunk<any, { RITM: string }>(
  "engagementHistory/getRITMActivityData",
  async (args, thunkAPI) => {
    try {
      const response = await RITMActivity(args);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const { setSnowForm, setCkms, setSnowPage } =
  engagementHistorySlice.actions;

export default engagementHistorySlice.reducer;
